import React, { useState, useEffect, useContext, useRef } from "react";
import { RxCross2 } from "react-icons/rx";
import { CiSearch } from "react-icons/ci";
import {
  FaStethoscope,
  FaRupeeSign,
  FaMapMarkerAlt,
  FaStar,
  FaDog,
  FaCat,
  FaChevronDown,
  FaChevronUp,
  FaSort,
} from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { IoMdCut } from "react-icons/io";
import { BsClock } from "react-icons/bs";
import FilterCard from "../../components/FilterCard";
import { useLocation, useNavigate } from "react-router-dom";
import { SearchContext } from "../../../context/SearchContext";
import VendorMap from "../../components/VendorMap";
import Fuse from "fuse.js";
import PriceRangeSlider from "./PriceRangeSlider";
import { useCart } from "../../../context/CartContext";
import { filterVisibleVendorServices } from "../../../utils/ServiceTypeMapping";

// Reusable button component for all filter options (Pet Type, Availability, Amenities)
const FilterToggleButton = ({ label, isActive, onClick, className }) => (
  <button
    onClick={onClick}
    className={`px-3 py-1 text-xs rounded-full transition-colors font-medium border 
            ${
              isActive
                ? "bg-[#FF6216] text-white border-[#FF6216]"
                : "bg-white text-[#1B4582] border-gray-300 hover:bg-[#FD590120]"
            } ${className || ""}`}
  >
    {label}
  </button>
);

const ShopDetail = () => {
  const [activeFilter, setActiveFilter] = useState(null);
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
  const [isSortDropdownOpen, setIsSortDropdownOpen] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const MIN_LIMIT = 0;
  const MAX_LIMIT = 10000;
  const SLIDER_STEP = 100;
  const [filters, setFilters] = useState({
    priceRange: [MIN_LIMIT, MAX_LIMIT],
    petType: [],
    availability: [],
    amenities: [],
    services: [],
    status: null,
    petSize: [],
  });

  const [selectedFilters, setSelectedFilters] = useState({
  priceRange: [MIN_LIMIT, MAX_LIMIT],
  petType: [],
  petSize: [],
  availability: [],
  amenities: [],
  services: [],
  status: null,
 });

 const { cartOpen } = useCart();

 
  const [hoveredVendorId, setHoveredVendorId] = useState(null);
  const [userLocation, setUserLocation] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  // ** DEFINITIVE FIX: Clear URL and DOM input on Hard Refresh (F5) **
  
  const handleTryAgain = () => {
  // 1. Get the last successful search parameters from storage
  const savedParamsRaw = localStorage.getItem("searchParams");
  const savedParams = savedParamsRaw ? JSON.parse(savedParamsRaw) : {};
  const lastSuccessfulPincode = savedParams?.pincode || "";

  // 2. Clear the local service/filter search bar
  setSearchQuery(""); 

  // 3. Reset the Header's Pincode Searchbar via Context
  // Change 'setPincode' to whatever the actual function name is in your context
  if (setPincode) {
    setPincode(lastSuccessfulPincode); 
  }

  // 4. Re-fetch data using the last successful pincode
  handleRefresh(); 
};

  const sortRef = useRef(null);
  const filterRef = useRef(null);
  const boardingRef = useRef(null);
  const groomingRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sortRef.current && !sortRef.current.contains(event.target)) {
        setIsSortDropdownOpen(false);
      }
      if (
  filterRef.current &&
  !filterRef.current.contains(event.target) &&
  window.innerWidth >= 1024 // 👈 IMPORTANT
) {
  setIsFilterDropdownOpen(false);
}
      if (boardingRef.current && !boardingRef.current.contains(event.target)) {
        if (activeSubMenu === "Boarding") {
          setActiveSubMenu(null);
        }
      }
      if (groomingRef.current && !groomingRef.current.contains(event.target)) {
        if (activeSubMenu === "Grooming") {
          setActiveSubMenu(null);
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeSubMenu]);

  const { vendors, setVendors, fetchVendors, setPincode ,loading, error } =
    useContext(SearchContext);

  const vendorsFromState = location.state?.vendors;

  const serviceNameMapping = {
    Veterinary: ["Pet Vet Clinic", "Pet Clinic", "Vet Services"],
  };

  const serviceSubCategories = {
    Boarding: ["Home boarding", "Kennel boarding", "Pet resort"],
    Grooming: ["Home Grooming", "Mobile Pet Grooming Van", "Grooming Salon"],
  };

  const serviceIcons = {
    Boarding: (
      <img src="/img/boysitting.png" alt="Boarding" className="w-6 h-6 mr-3" />
    ),
    Veterinary: <FaStethoscope className="w-6 h-6 mr-3" />,
    Grooming: <IoMdCut className="w-6 h-6 mr-3" />,
  };

  const sortIcons = {
    Price: <FaRupeeSign className="w-5 h-5 mr-3" />,
    Distance: <FaMapMarkerAlt className="w-5 h-5 mr-3" />,
  };

  const normalizeVendors = (data) => {
    if (!data) return [];
    if (Array.isArray(data)) {
      if (data.length === 1 && Array.isArray(data[0]?.data)) {
        return data[0].data;
      }
      if (data.every((v) => v._id)) {
        return data;
      }
    }
    if (data && Array.isArray(data.data)) return data.data;
    if (data && Array.isArray(data.vendors)) return data.vendors;
    if (data) return [data];
    return [];
  };

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            lat: position.coords.latitude,
            lon: position.coords.longitude,
          });
        },
        (err) => {
          console.error("Geolocation error:", err);
        }
      );
    }
  }, []);

  const deg2rad = (deg) => deg * (Math.PI / 180);

  const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of the Earth in km
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const [localVendors, setLocalVendors] = useState(() => {
    if (vendorsFromState) return normalizeVendors(vendorsFromState);
    if (vendors && vendors.length > 0) return normalizeVendors(vendors);

    const savedVendors = localStorage.getItem("vendors");
    if (savedVendors) return normalizeVendors(JSON.parse(savedVendors));

    return [];
  });
  // Keep local vendors in sync with context updates
  useEffect(() => {
    if (vendors && vendors.length > 0) {
      setLocalVendors(normalizeVendors(vendors));
    }
  }, [vendors]);

  // Keep local vendors in sync with navigation state updates
  useEffect(() => {
    if (vendorsFromState) {
      setLocalVendors(normalizeVendors(vendorsFromState));
    }
  }, [vendorsFromState]);
  // On hard refresh, mirror the pincode search flow
  useEffect(() => {
    handleRefresh();
    // run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  

  const toggleSubMenu = (menu) => {
    setActiveSubMenu((prev) => (prev === menu ? null : menu));
  };

  const toggleFilter = (filter) => {
    setActiveFilter((prev) => (prev === filter ? null : filter));
    setIsSortDropdownOpen(false); // Close sort dropdown on selection
  };

  const toggleSortDropdown = () => {
    setIsSortDropdownOpen(!isSortDropdownOpen);
    setIsFilterDropdownOpen(false);
  };

  const toggleFilterDropdown = () => {
    setIsFilterDropdownOpen((prev) => !prev);
    setIsSortDropdownOpen(false);
  };

  const toggleSimpleService = (service) => {
    setFilters((prev) => {
      const newServices = prev.services.includes(service)
        ? prev.services.filter((s) => s !== service)
        : [...prev.services, service];
      return { ...prev, services: newServices };
    });
  };

  const toggleSubService = (subService) => {
    setFilters((prev) => {
      const newServices = prev.services.includes(subService)
        ? prev.services.filter((s) => s !== subService)
        : [...prev.services, subService];
      return { ...prev, services: newServices };
    });
    setActiveSubMenu(null); // Close the sub-menu on selection
  };

  const handlePetTypeToggle = (type) => {
  setSelectedFilters((prev) => ({
    ...prev,
    petType: prev.petType.includes(type)
      ? prev.petType.filter((t) => t !== type)
      : [...prev.petType, type],
  }));
 };

   const togglePetSize = (size) => {
  setSelectedFilters((prev) => ({
    ...prev,
    petSize: prev.petSize.includes(size)
      ? prev.petSize.filter((s) => s !== size)
      : [...prev.petSize, size],
  }));
};

  const setStatusFilter = (status) => {
    setSelectedFilters((prev) => ({
      ...prev,
      status: prev.status === status ? null : status,
    }));
  };
  // for availability on business hour
  const dayMap = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  };
  const dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  // Helper function to check if a vendor is open on a specific day name
  const isOpenOnDay = (vendor, targetDate) => {
    if (!vendor.businessHours || vendor.businessHours.length === 0) {
      return false;
    }
    const targetDayIndex = targetDate.getDay();
    const daySchedule = vendor.businessHours.find(
      (schedule) => dayMap[schedule.day] === targetDayIndex
    );
    return (
      daySchedule &&
      daySchedule.closed === false &&
      daySchedule.slots &&
      daySchedule.slots.length > 0
    );
  };

  // Helper to convert time string (e.g., "10:00 AM") to minutes past midnight
  const timeToMinutes = (timeStr) => {
    if (!timeStr || typeof timeStr !== "string") return 0;
    const parts = timeStr.trim().match(/(\d{1,2}):(\d{2})\s*([AP]M)?/i);
    if (!parts) {
      console.error(
        `[TIME PARSE ERROR] Failed to parse time string: "${timeStr}"`
      );
      return 0;
    }
    let [_, hours, minutes, period] = parts;
    hours = parseInt(hours, 10);
    minutes = parseInt(minutes, 10);

    // Normalize hours based on AM/PM
    if (period) {
      // Check if AM/PM exists
      const upperPeriod = period.toUpperCase();
      if (upperPeriod === "PM" && hours !== 12) {
        hours += 12;
      } else if (upperPeriod === "AM" && hours === 12) {
        hours = 0; // 12:xx AM is midnight (0 hours)
      }
    }

    return hours * 60 + minutes;
  };
  /* Calculates the current business status (Open/Closed NOW).*/
  const getTodayBusinessStatus = (vendor, isSearchActive, localVendors) => {
    const now = new Date();

    // Default debug info
    let debugInfo = "";

    // 1. Day Check
    if (!isOpenOnDay(vendor, now)) {
      debugInfo = "(Closed Today)";
      return { status: "Closed", hours: "", isOpenNow: false, debugInfo };
    }

    const todayDayIndex = now.getDay();
    const schedule = vendor.businessHours.find(
      (s) => dayMap[s.day] === todayDayIndex
    );

    // Extract times from the first slot
    const startTime = schedule.slots[0].start;
    const endTime = schedule.slots[0].end;

    if (!startTime || !endTime) {
      debugInfo = "(Missing Times)";
      return { status: "Closed", hours: "", isOpenNow: false, debugInfo };
    }

    const hoursDisplay = `${startTime} - ${endTime}`;

    // 2. Time Check
    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    const startMinutes = timeToMinutes(startTime);
    const endMinutes = timeToMinutes(endTime);

    let isOpenNow = false;

    if (startMinutes <= endMinutes) {
      // Standard operating hours
      isOpenNow =
        currentMinutes >= startMinutes && currentMinutes <= endMinutes;
    } else {
      // Handle wrap-around midnight
      isOpenNow =
        currentMinutes >= startMinutes || currentMinutes <= endMinutes;
    }

    // Capture the critical numbers for screen display ONLY when search is active
    // S: Start Minutes, E: End Minutes, C: Current Minutes
    if (isSearchActive) {
      debugInfo = ` (S:${startMinutes}, E:${endMinutes}, C:${currentMinutes} -> ${
        isOpenNow ? "OPEN" : "CLOSED"
      })`;
    }

    return {
      status: isOpenNow ? "Open Now" : "Closed",
      hours: hoursDisplay,
      isOpenNow: isOpenNow,
      debugInfo: debugInfo, // <-- Returning the debug string
    };
  };

  useEffect(() => {
    if (isFilterDropdownOpen) {
      const scrollY = window.scrollY; // Capture current scroll position

      // 1. Prevent vertical scroll
      document.body.style.overflow = "hidden";

      // 2. iOS/Mobile Fix: Fixes the body position to prevent scrolling/jumping
      document.body.style.position = "fixed";
      document.body.style.width = "100%";

      // 3. Hold the scroll position (prevents jump when setting position: fixed)
      document.body.style.top = `-${scrollY}px`;
    } else {
      const scrollY = document.body.style.top;

      // 4. Restore scroll settings
      document.body.style.overflow = "unset";
      document.body.style.position = "unset";
      document.body.style.width = "auto";

      // 5. Restore original scroll position
      if (scrollY) {
        // Remove the negative sign and convert to number
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
      }
      document.body.style.top = ""; // Clear the inline style
    }

    // Cleanup function: runs when the component unmounts or state changes
    return () => {
      document.body.style.overflow = "unset";
      document.body.style.position = "unset";
      document.body.style.width = "auto";
      document.body.style.top = "";
    };
  }, [isFilterDropdownOpen]);

  // Scroll lock for Sort Modal (Mobile/Tablet)
  useEffect(() => {
    if (isSortDropdownOpen) {
      const scrollY = window.scrollY;

      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
      document.body.style.top = `-${scrollY}px`;
    } else {
      const scrollY = document.body.style.top;

      document.body.style.overflow = "unset";
      document.body.style.position = "unset";
      document.body.style.width = "auto";

      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
      }
      document.body.style.top = "";
    }

    return () => {
      document.body.style.overflow = "unset";
      document.body.style.position = "unset";
      document.body.style.width = "auto";
      document.body.style.top = "";
    };
  }, [isSortDropdownOpen]);

  const handleAmenityToggle = (amenity) => {
  setSelectedFilters((prev) => ({
    ...prev,
    amenities: prev.amenities.includes(amenity)
      ? prev.amenities.filter((a) => a !== amenity)
      : [...prev.amenities, amenity],
  }));
};

  const handleAvailabilityToggle = (option) => {
   setSelectedFilters((prev) => {
      const currentAvailability = Array.isArray(prev.availability)
        ? prev.availability
        : [];

      return {
        ...prev,
        availability: currentAvailability.includes(option)
          ? currentAvailability.filter((a) => a !== option)
          : [...currentAvailability, option],
      };
    });
  };
  const handlePriceRangeChange = (e) => {
    const newValue = Number(e.target.value);
    setSelectedFilters((prev) => {
      return {
        ...prev,
        priceRange: [MIN_LIMIT, newValue], // Min is fixed at MIN_LIMIT
      };
    });
  };

  const clearFilters = () => {
   const reset = {
    priceRange: [MIN_LIMIT, MAX_LIMIT],
    petType: [],
    availability: [],
    amenities: [],
    services: [],
    status: null,
    petSize: [],
  };

  setFilters(reset);          // applied filters
  setSelectedFilters(reset);
  };

   const removeSelectedFilter = (category, value) => {
  setSelectedFilters((prev) => {
    const updated = {
      ...prev,
      [category]: prev[category].filter((item) => item !== value),
    };
    setFilters(updated); // immediately apply the new filters
    return updated;
  });
};
 const removeFilterPill = (category, value) => {
  // Remove from dropdown selections
  setSelectedFilters((prev) => ({
    ...prev,
    [category]: prev[category].filter((item) => item !== value),
  }));

  // Remove from applied filters (if you want instant filtering)
  setFilters((prev) => ({
    ...prev,
    [category]: prev[category].filter((item) => item !== value),
  }));
};


  const clearFiltersAndSort = () => {
    clearFilters();
    setActiveFilter(null);
    setIsFilterDropdownOpen(false);
    setIsSortDropdownOpen(false);
  };

  const handleRefresh = async () => {
    try {
      const savedParamsRaw = localStorage.getItem("searchParams");
      const savedParams = savedParamsRaw ? JSON.parse(savedParamsRaw) : {};
      const radius = savedParams?.radius || 17;

      // Prefer saved pincode; else try to derive from local vendors
      let overridePincode = savedParams?.pincode;
      if (!overridePincode && localVendors && localVendors.length > 0) {
        overridePincode =
          localVendors[0]?.address?.officeAddress?.pincode ||
          localVendors[0]?.pincode ||
          null;
      }

      if (!overridePincode) {
        // If we still don't have a pincode, keep current view and skip fetching
        return;
      }

      const result = await fetchVendors(radius, overridePincode);
      if (result) {
        // We are already on /shop-detail; no need to navigate to same route
        setLocalVendors(normalizeVendors(result));
      }
    } catch (error) {
      console.error("Error refreshing vendors:", error);
    }
  };
  //searchbar query
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  //let vendorsToRender = JSON.parse(localStorage.getItem("vendors"))
  // --- HELPER FUNCTIONS FOR SORTING/DISPLAY DATA ---
  const calculateLowestPrice = (vendor) => {
  const settings = vendor.priceSettings;

    if (
      !settings ||
      settings === null ||
      typeof settings.minimumPrice !== "number" ||
      settings.minimumPrice <= 0
    ) {
      return Infinity; // 👈 key change
    }

    return settings.minimumPrice;
  };

  const calculateBestRating = (vendor) => {
  // Path 1: reviews.rating (from your DB structure)
  // Path 2: start_rating (fallback)
  const ratingValue = vendor.reviews?.rating || vendor.start_rating;

  if (!ratingValue || ratingValue === "No Rating") return 0;
  
  return parseFloat(ratingValue) || 0;
};

  const DAYS_OF_WEEK = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const isTimeBefore = (time1, time2) => {
    const [h1, m1] = time1.split(":").map(Number);
    const [h2, m2] = time2.split(":").map(Number);
    if (h1 !== h2) return h1 < h2;
    return m1 < m2;
  };

  const getNextOpenTime = (businessHours) => {
    if (!Array.isArray(businessHours)) {
      return { day: "N/A", time: "N/A" };
    }
    const now = new Date();
    const currentDayIndex = now.getDay();

    for (let i = 1; i <= 7; i++) {
      const checkDayIndex = (currentDayIndex + i) % 7;
      const checkDayName = DAYS_OF_WEEK[checkDayIndex];

      const daySchedule = businessHours.find((day) => day.day === checkDayName);

      if (
        daySchedule &&
        !daySchedule.closed &&
        daySchedule.slots &&
        daySchedule.slots.length > 0
      ) {
        return {
          day: daySchedule.day,
          time: daySchedule.slots[0].start,
        };
      }
    }
    return { day: "N/A", time: "N/A" };
  };
  const getAvailabilityStatus = (businessHours) => {
    if (!Array.isArray(businessHours)) {
      console.error("businessHours is not an array:", businessHours);
      return {
        status: "Closed",
        isOpenNow: false,
        nextOpen: "Schedule Unavailable",
      };
    }

    const now = new Date();
    const currentDayName = DAYS_OF_WEEK[now.getDay()];
    // Get current time in HH:MM format
    const currentTime = `${String(now.getHours()).padStart(2, "0")}:${String(
      now.getMinutes()
    ).padStart(2, "0")}`;

    const todaySchedule = businessHours?.find(
      (day) => day.day === currentDayName
    );
    let statusObject = { status: "Closed", isOpenNow: false, nextOpen: "" };

    

    // 1. Check if closed today or no schedule
    if (
      !todaySchedule ||
      todaySchedule.closed ||
      !todaySchedule.slots ||
      todaySchedule.slots.length === 0
    ) {
      // ... rest of closed logic ...
      const nextOpen = getNextOpenTime(businessHours);
      if (nextOpen.day !== "N/A") {
        statusObject.nextOpen = `Opens ${nextOpen.day} at ${nextOpen.time}`;
      } else {
        statusObject.status = "Permanently Closed";
      }
      return statusObject;
    }

    // 2. Check if currently within operating hours
    for (const slot of todaySchedule.slots) {
      const isAfterStart = !isTimeBefore(currentTime, slot.start);
      const isBeforeEnd = isTimeBefore(currentTime, slot.end);

      

      // Check if current time is >= start time AND < end time
      if (isAfterStart && isBeforeEnd) {
       
        return {
          status: "Open Now",
          isOpenNow: true,
          nextOpen: `Closes today at ${slot.end}`,
        };
      }
    }

    // 3. Find next open time (either later today or another day)
    const nextTodaySlot = todaySchedule.slots.find((slot) =>
      isTimeBefore(currentTime, slot.start)
    );

    if (nextTodaySlot) {
      statusObject.nextOpen = `Opens today at ${nextTodaySlot.start}`;
     
      return statusObject;
    }

    const nextOpen = getNextOpenTime(businessHours);

    statusObject.nextOpen =
      nextOpen.day !== "N/A"
        ? `Opens ${nextOpen.day} at ${nextOpen.time}`
        : "No more open hours scheduled.";
  
    return statusObject;
  };

  const isShopIntent = (q) => /shop|store|in-?store/i.test(q);
  const isHomeIntent = (q) => /home|delivery|mobile|service/i.test(q);

  // fuse code
 const fuse = React.useMemo(() => {
     const searchableVendors = localVendors.map((v) => {
  const { status, nextOpen } = getAvailabilityStatus(v.businessHours);

  const allServiceText = (v.services || [])
    .flatMap((cat) => [
      cat.service_category_name || "",
      cat.service_type_name || "",
      ...(cat.services || []).map(s => s.name || ""),
    ])
    .filter(Boolean)
    .join("  ");

  return {
    ...v,
    name: (v.profile?.brand || v.profile?.companyName || v.name || "").toLowerCase(),
    companyName: (v.profile?.companyName || "").toLowerCase(),
    about: (v.profile?.about || "").toLowerCase(),
    full_address: (v.address?.officeAddress?.full_address || "").toLowerCase(),
    locality: (v.address?.officeAddress?.locality || "").toLowerCase(),
    city: (v.address?.officeAddress?.city || "").toLowerCase(),
    subscription_type: (v.subscription_type || "").toLowerCase().trim(),
    serviceText: allServiceText.toLowerCase(),
    availabilityStatus: status.toLowerCase(),
    nextOpenInfo: nextOpen.toLowerCase(),
  };
});
  
  const options = {
  keys: [
    { name: "name", weight: 2.0 },
    { name: "companyName", weight: 1.8 },
    { name: "serviceText", weight: 1.5 },          // services should win over address
    { name: "full_address", weight: 0.7 },
    { name: "locality", weight: 1.0 },
    { name: "city", weight: 0.6 },
    { name: "about", weight: 0.4 },
    { name: "subscription_type", weight: 0.9 },    // moderate — enough to help, not dominate
    { name: "availabilityStatus", weight: 0.25 },
    { name: "nextOpenInfo", weight: 0.2 },
  ],
  threshold: 0.38,           // Good typo tolerance (from recent guides: 0.3–0.4 common)
  distance: 150,             // Allow matches deep in addresses
  ignoreLocation: true,
  minMatchCharLength: 2,
  shouldSort: true,
  includeScore: true,
  useExtendedSearch: true,
};
  return new Fuse(searchableVendors, options);
}, [localVendors]);

  let vendorsToRender = [...localVendors];
  

  const availabilityKeywords = ["open", "available"];

  //  SEARCH FILTER (USING MEMOIZED FUSE INSTANCE)
   if (searchQuery?.trim()) {
  const raw = searchQuery.trim();
  const queryLower = raw.toLowerCase();

  // Intent detection
  const wantsShop     = /shop|store|pet store|in-?store/i.test(queryLower);
  const wantsHome     = /home|delivery|mobile|at home|doorstep/i.test(queryLower);
  const isAvailability = /open|open now|available|availbl|today|now/i.test(queryLower);

  let query = raw
    .replace(/[^\w\s-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  // typo fixes...
  const fixes = { veterenary: 'veterinary', grrom: 'groom', bord: 'board', kenel: 'kennel' };
  Object.entries(fixes).forEach(([bad, good]) => {
    if (queryLower.includes(bad)) query = query.replace(new RegExp(bad, 'gi'), good);
  });

  // Start with all vendors
  let filtered = [...localVendors];

  // Apply strong intent filters
  if (wantsShop) {
    filtered = filtered.filter(v => (v.subscription_type || '').toLowerCase() === 'shop');
  } else if (wantsHome) {
    filtered = filtered.filter(v => (v.subscription_type || '').toLowerCase() === 'home');
  }

  if (isAvailability) {
    filtered = filtered.filter(v => getAvailabilityStatus(v.businessHours).isOpenNow);
  }

  // If query is basically just the intent keyword → return filtered list directly
  const isShortIntent = (wantsShop || wantsHome || isAvailability) && query.length <= 8;

  if (isShortIntent || !query) {
    vendorsToRender = filtered;
  } else {
    // Use the **memoized** fuse, but only on the filtered subset
    const results = fuse.search(query, { limit: 50 });  // optional limit

    // Only keep results that are in the filtered list
    const filteredIds = new Set(filtered.map(v => v._id || v.vendor_id));
    vendorsToRender = results
      .map(r => r.item)
      .filter(item => filteredIds.has(item._id || item.vendor_id));
  }

  // Debug
  console.table(vendorsToRender.slice(0, 6).map(v => ({
    name: v.profile?.brand || v.name || "—",
    sub: v.subscription_type,
    available: getAvailabilityStatus(v.businessHours).status
  })));
} else {
  vendorsToRender = [...localVendors];
}

  const finalRenderListWithStatus = vendorsToRender.map((v) => {
    // Re-calculate or reuse the status for display consistency
    const { status, nextOpen } = getAvailabilityStatus(v.businessHours);
    return {
      ...v,

      // Overwrite or guarantee the necessary display fields
      _id: v.vendor_id || v._id,
      name: v.name || v.profile?.brand,
      companyName: v.companyName || v.profile?.companyName,
      area: v.area || v.address?.officeAddress?.full_address || "",
      subscription_type: v.subscription_type || "",
      available: status,
      availableNextOpen: nextOpen,
    };
  });

  if (vendorsToRender.length > 0) {
    

    vendorsToRender.forEach((vendor, index) => {
      // Logging the full object for inspection 
      
    });
  }
  if (filters.services.length > 0) {
    const serviceGroups = {
      Boarding: [],
      Grooming: [],
      Veterinary: [],
      Other: [],
    };
    let services = [];
    filters.services.forEach((service) => {
      if (serviceSubCategories.Boarding.includes(service)) {
        serviceGroups.Boarding.push(service);
      } else if (serviceSubCategories.Grooming.includes(service)) {
        serviceGroups.Grooming.push(service);
      } else if (service === "Veterinary") {
        // Check explicitly for the Veterinary button
        serviceGroups.Veterinary.push(service);
      } else {
        serviceGroups.Other.push(service);
      }
    });

    vendorsToRender = vendorsToRender.filter((vendor) => {
      if (!vendor.services || !Array.isArray(vendor.services)) {
        return false;
      }
      const vendorServices = vendor.services.map((s) =>
        s["service_type_name"].toLowerCase()
      );

      const boardingMatch =
        serviceGroups.Boarding.length === 0 ||
        serviceGroups.Boarding.some((sub) =>
          vendorServices.some((s) =>
            s.toLowerCase().includes(sub.toLowerCase())
          )
        );
      const groomingMatch =
        serviceGroups.Grooming.length === 0 ||
        serviceGroups.Grooming.some((sub) =>
          //vendorServices.includes(sub.toLowerCase())
          vendorServices.some((s) =>
            s.toLowerCase().includes(sub.toLowerCase())
          )
        );
      const veterinaryMatch =
        serviceGroups.Veterinary.length === 0 || // If Veterinary isn't selected, return true
        serviceGroups.Veterinary.every(() => {
          // Check if the vendor has the actual service name
          const actualVendorNames = serviceNameMapping["Veterinary"] || [];
          return actualVendorNames.some((requiredName) =>
            vendorServices.some((vendorName) =>
              vendorName.includes(requiredName.toLowerCase())
            )
          );
        });
      const otherMatch =
        serviceGroups.Other.length === 0 ||
        serviceGroups.Other.every((sub) =>
          // vendorServices.includes(s.toLowerCase())
          //new
          vendorServices.some((s) =>
            s.toLowerCase().includes(sub.toLowerCase())
          )
        );

      return boardingMatch && groomingMatch && veterinaryMatch && otherMatch;
    });
  }
  
   if (filters.petType.length > 0) {
     vendorsToRender = vendorsToRender.filter((vendor) => {
      if (!vendor.petTyps || vendor.petTyps.length === 0) return false;

      return filters.petType.some((selectedType) =>
       vendor.petTyps.some(
         (vendorType) =>
          vendorType.toLowerCase() === selectedType.toLowerCase()
       )
     );
   });
  }

  if (filters.petSize.length > 0) {
     vendorsToRender = vendorsToRender.filter((vendor) => {
      if (!vendor.petSizes || vendor.petSizes.length === 0) return false;

      return filters.petSize.some((selectedSize) =>
       vendor.petSizes.some(
         (vendorSize) =>
           vendorSize.toLowerCase() === selectedSize.toLowerCase()
       )
     );
    });
  }

  if (filters.status) {
    vendorsToRender = vendorsToRender.filter(
      (vendor) =>
        vendor.status &&
        filters.status.some((status) => vendor.status === status)
    );
  }

  if (Array.isArray(filters.availability) && filters.availability.length > 0) {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    vendorsToRender = vendorsToRender.filter((vendor) => {
      return filters.availability.some((option) => {
        if (option === "Today") {
          return isOpenOnDay(vendor, today);
        }
        if (option === "Tomorrow") {
          return isOpenOnDay(vendor, tomorrow);
        }
        return false; // Should not happen
      });
    });
  }
 

  // --- 7. PRICE RANGE FILTER---
  const [minPrice, maxPrice] = filters.priceRange;
  if (maxPrice < MAX_LIMIT) {
    // Only filter if the slider has moved from the max
    vendorsToRender = vendorsToRender.filter((vendor) => {
      // Use the helper function to get the vendor's price
      const vendorPrice = calculateLowestPrice(vendor);
      if (vendorPrice === Infinity) return false ; 
      //if (vendorPrice === 0) return false;
      return vendorPrice >= minPrice && vendorPrice <= maxPrice;
    });
  }

  const sortedVendors = [...vendorsToRender];

  if (activeFilter === "Price: Low To High") {
    sortedVendors.sort((a, b) => {
      const priceA = calculateLowestPrice(a);
      const priceB = calculateLowestPrice(b);

      if (priceA === Infinity && priceB === Infinity) return 0;
      if (priceA === Infinity) return 1;
      if (priceB === Infinity) return -1;


      if (priceA === priceB) {
        // Secondary: alphabetical by name/company
        const nameA = (a.profile?.companyName || a.profile?.name || "").toLowerCase();
        const nameB = (b.profile?.companyName || b.profile?.name || "").toLowerCase();
        return nameA.localeCompare(nameB);
      }

      return priceA - priceB;
        //return calculateLowestPrice(a) - calculateLowestPrice(b);
      });
      } else if (activeFilter === "Price: High To Low") {
        sortedVendors.sort((a, b) => {
        
      const priceA = calculateLowestPrice(a);
      const priceB = calculateLowestPrice(b);

      if (priceA === Infinity && priceB === Infinity) return 0;
      if (priceA === Infinity) return 1;
      if (priceB === Infinity) return -1;

      if (priceA === priceB) {
        const nameA = (a.profile?.companyName || a.profile?.name || "").toLowerCase();
        const nameB = (b.profile?.companyName || b.profile?.name || "").toLowerCase();
        return nameB.localeCompare(nameA);
      }

      return priceB - priceA;

     // return calculateLowestPrice(b) - calculateLowestPrice(a);
    });
  } else if (activeFilter === "Distance: Nearest First" && userLocation) {
    sortedVendors.sort((a, b) => {
      const getCoords = (v) => {
        const lat = v?.address?.officeAddress?.latitude ?? v?.lat;
        const lon = v?.address?.officeAddress?.longitude ?? v?.long;
        return lat && lon
          ? getDistanceFromLatLonInKm(
              userLocation.lat,
              userLocation.lon,
              lat,
              lon
            )
          : Number.MAX_SAFE_INTEGER;
      };
      return getCoords(a) - getCoords(b);
    });
  } else if (activeFilter === "Rating: High To Low") {
    // Sort by Rating: Descending (High to Low)
    sortedVendors.sort((a, b) => {
      return calculateBestRating(b) - calculateBestRating(a);
    });
  }
  const selectedBoardingServices = filters.services.filter((s) =>
    serviceSubCategories.Boarding.includes(s)
  );
  const selectedGroomingServices = filters.services.filter((s) =>
    serviceSubCategories.Grooming.includes(s)
  );
  const isVeterinarySelected = filters.services.includes("Veterinary");

  const displayVendors = sortedVendors;
  

  return (
    <div className="flex flex-col gap-4 mt-2 lg:px-10">
      {/* Error State */}
        {error ? (
          <div className="mt-8 text-center">
            <div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded max-w-md mx-auto">
              <p className="font-semibold">Error loading vendors</p>
              <p className="text-sm mt-1">{error}</p>
              <button
                onClick={handleTryAgain}
                className="mt-3 bg-[#FF6216] text-white px-4 py-2 rounded hover:bg-[#e05514]"
              >
                Try Again
              </button>
            </div>
          </div>
        ) : (
        <>
      <div>
        <div className="flex justify-center items-center lg:px-8 xl:px-12 px-4 pt-3">
          <div className="flex flex-col md:flex-row xl:flex-nowrap lg:flex-wrap md:flex-wrap justify-between items-center w-full gap-2 md:gap-4 pb-3">
            {/* 1. Service Buttons (Boarding, Grooming, Veterinary) */}
            <div className="flex items-center gap-2 flex-shrink-0 overflow-x-auto pb-1 w-full md:w-auto md:overflow-visible">
              {/* Boarding Button */}
              <div
                className="relative inline-block text-left flex-shrink-0"
                ref={boardingRef}
              >
                <button
                  type="button"
                  onClick={() => toggleSubMenu("Boarding")}
                  className="flex items-center justify-center gap-0.5 border border-[#FD590133] rounded-full px-6 py-3 text-sm  md:gap-4 md:px-6 md:py-3 md:text-[18px] transition-colors"
                >
                  <span className="hidden md:block">
                    {serviceIcons.Boarding}
                  </span>
                  <p className="text-[#1B4582] text-sm lg:text-[18px] flex-shrink-0">
                    Boarding
                  </p>
                  <FaChevronDown className="w-2.5 h-2.5 text-[#1B4582]" />
                </button>
                {/* Boarding Dropdown - Position remains fixed on mobile relative to viewport */}
                {activeSubMenu === "Boarding" && (
                  <div
                    className="origin-top-left fixed top-[120px] left-1/4 -translate-x-1/2 w-full max-w-[12rem] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50 
                   md:absolute md:top-full md:left-0 md:translate-x-0 md:mt-1 md:max-w-xs md:w-80"
                  >
                    <div className="p-1">
                      {serviceSubCategories.Boarding.map((subService) => {
                        const isSelected =
                          filters.services.includes(subService);
                        return (
                          <button
                            key={subService}
                            onClick={() => toggleSubService(subService)}
                            className={`w-full text-left px-3 py-2 text-sm flex items-center rounded-lg transition-colors ${
                              isSelected
                                ? "bg-[#FF6216] text-white"
                                : "text-[#1B4582] hover:bg-[#FD590120]"
                            }`}
                          >
                            <span className="flex-grow text-sm">
                              {subService}
                            </span>
                            {isSelected && (
                              <RxCross2 className="ml-2 text-[20px]" />
                            )}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>

              {/* Grooming Button */}
              <div
                className="relative inline-block text-left flex-shrink-0"
                ref={groomingRef}
              >
                <button
                  type="button"
                  onClick={() => toggleSubMenu("Grooming")}
                  className="flex items-center justify-center gap-0.5 border border-[#FD590133] rounded-full px-6 py-3 text-sm md:gap-4 md:px-6 md:py-3 md:text-[18px] transition-colors"
                >
                  <span className="hidden md:block">
                    {serviceIcons.Grooming}
                  </span>
                  <p className="text-[#1B4582] text-sm lg:text-[18px] flex-shrink-0">
                    Grooming
                  </p>
                  <FaChevronDown className="w-2.5 h-2.5 text-[#1B4582]" />
                </button>
                {/* Grooming Dropdown */}
                {activeSubMenu === "Grooming" && (
                  <div
                    className="origin-top-left fixed top-[120px] left-1/2 -translate-x-1/2 w-full max-w-[12rem] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50 
                   md:absolute md:top-full md:left-0 md:translate-x-0 md:mt-1 md:max-w-xs md:w-80"
                  >
                    <div className="p-1">
                      {serviceSubCategories.Grooming.map((subService) => {
                        const isSelected =
                          filters.services.includes(subService);
                        return (
                          <button
                            key={subService}
                            onClick={() => toggleSubService(subService)}
                            className={`w-full text-left px-3 py-2 text-sm flex items-center rounded-lg transition-colors ${
                              isSelected
                                ? "bg-[#FF6216] text-white"
                                : "text-[#1B4582] hover:bg-[#FD590120]"
                            }`}
                          >
                            <span className="flex-grow text-sm">
                              {subService}
                            </span>
                            {isSelected && (
                              <RxCross2 className="ml-2 text-[20px]" />
                            )}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>

              {/* Veterinary Button */}
              <div className="w-auto flex-shrink-0">
                <button
                  type="button"
                  onClick={() => {
                    toggleSimpleService("Veterinary");
                    setActiveSubMenu(null);
                  }}
                  className={`flex items-center justify-center gap-0.5 border rounded-full px-6 py-3 text-sm md:gap-4 md:px-6 md:py-3 md:text-[18px] transition-colors w-full sm:w-auto ${
                    filters.services.includes("Veterinary")
                      ? "bg-[#FF6216] text-white border-[#FF6216]"
                      : "bg-white text-[#1B4582] border-[#FD590133] hover:bg-[#FD590120]"
                  }`}
                >
                  <span className="hidden md:block">
                    {serviceIcons.Veterinary}
                  </span>
                  <p className="text-sm lg:text-[18px] flex-shrink-0">
                    Veterinary
                  </p>
                </button>
              </div>
            </div>

            {/* 2. Search Input */}
            <div className="relative flex items-center w-full lg:w-96 lg:px-86mt-2 md:mt-0">
              <input
                type="text"
                placeholder="search for a service, shop, boarding, vet etc.."
                value={searchQuery}
                onChange={handleSearchChange}
                className="border border-gray-300 rounded-full py-3.5 px-4 pl-10 w-full focus:outline-none focus:ring-2 focus:ring-[#FD5901] text-base md:text-base"
              />
              <CiSearch
                className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
                size={20}
              />
            </div>
            <div className="hidden lg:flex items-center gap-2 md:gap-4 w-full md:w-auto justify-end flex-wrap xl:flex-nowrap mt-2 md:mt-0 min-h-0 overflow-visible">
              <div
                className="relative inline-block text-left w-auto"
                ref={filterRef}
              >
                <button
                  type="button"
                  onClick={toggleFilterDropdown}
                  className={`flex items-center justify-center gap-1 border border-[#FD590133] rounded-full px-2 py-3 text-sm font-medium md:gap-4 md:px-6 md:py-3 md:text-[18px] w-full transition-colors 
                        ${
                          isFilterDropdownOpen
                            ? "bg-[#FF6216] text-white border-[#FF6216]"
                            : "bg-white text-[#1B4582] border-[#FD590133] hover:bg-[#FD590120]"
                        }`}
                >
                  {isFilterDropdownOpen ? (
                    <FaChevronUp className="w-3 h-3 md:w-4 md:h-4" />
                  ) : (
                    <FaChevronDown className="w-3 h-3 md:w-4 md:h-4" />
                  )}
                  <p className="text-base lg:text-[18px]">Filter</p>
                </button>
                {/* DESKTOP DROPDOWN (Positioned relative to button) */}
                {isFilterDropdownOpen && (
                  <div className="hidden lg:block absolute right-0 left-auto translate-x-0 mt-3 w-full max-w-xl sm:w-[500px] bg-white rounded-2xl shadow-2xl p-4 ring-1 ring-gray-200 focus:outline-none z-30 animate-[slideDown_0.3s_ease-out] border border-gray-100 max-h-[55dvh] xl:max-h-[75vh] overflow-y-auto overscroll-contain"
                  style={{ WebkitOverflowScrolling: "touch" }}
                  >
                    <div className="mb-3 p-3 bg-gradient-to-br from-orange-50 to-white rounded-xl border border-orange-100">
                      <h4 className="font-bold text-sm text-[#1B4582] mb-3 flex items-center gap-2">
                        <span className="text-orange-500">💰</span>
                        Price Range
                      </h4>
                      <div className="flex gap-1">
                        <PriceRangeSlider
                          minLimit={MIN_LIMIT}
                          maxLimit={MAX_LIMIT}
                          step={SLIDER_STEP}
                          priceRange={selectedFilters.priceRange}
                          onRangeChange={handlePriceRangeChange}
                        />
                      </div>
                    </div>
                    {/* Pet Type Section */}
                    <div className="mb-3 p-3 bg-gradient-to-br from-blue-50 to-white rounded-xl border border-blue-100">
                      <h4 className="font-bold text-sm text-[#1B4582] mb-3 flex items-center gap-2">
                        <span className="text-blue-500">🐾</span>
                        Pet Type
                      </h4>
                      <div className="flex gap-2 mb-2">
                        {["Dog", "Cat"].map((type) => (
                          <FilterToggleButton
                            key={type}
                            label={type}
                            isActive={selectedFilters.petType.includes(type)}
                            onClick={() => handlePetTypeToggle(type)}
                            className="text-sm px-4 py-2 hover:scale-105 transition-transform"
                          />
                        ))}
                      </div>
                    </div>
                    {/* Pet Size Section */}
                   {/* <div className="mb-3 p-3 bg-gradient-to-br from-purple-50 to-white rounded-xl border border-purple-100">
                      <h4 className="font-bold text-sm text-[#1B4582] mb-3 flex items-center gap-2">
                        <span className="text-purple-500">📏</span>
                        Pet Size
                      </h4>
                      <div className="flex gap-2 mb-2 flex-wrap">
                        {["Small", "Medium", "Large", "Giant"].map((size) => (
                          <FilterToggleButton
                            key={size}
                            label={size}
                            isActive={selectedFilters.petSize.includes(size)}
                            onClick={() => togglePetSize(size)}
                            className="text-xs px-3 py-2 hover:scale-105 transition-transform"
                          />
                        ))}
                      </div>
                    </div> */}
                    {/* Availability Section */}
                    <div className="mb-3 p-3 bg-gradient-to-br from-green-50 to-white rounded-xl border border-green-100">
                      <h4 className="font-bold text-sm text-[#1B4582] mb-3 flex items-center gap-2">
                        <span className="text-green-500">📅</span>
                        Availability
                      </h4>
                      <div className="flex gap-2 mb-2">
                        {["Today", "Tomorrow"].map((option) => (
                          <FilterToggleButton
                            key={option}
                            label={option}
                            isActive={selectedFilters.availability.includes(option)}
                            onClick={() => handleAvailabilityToggle(option)}
                            className="text-sm px-4 py-2 hover:scale-105 transition-transform"
                          />
                        ))}
                      </div>
                    </div>
                    {/* Amenities Section */}
                    <div className="mb-3 p-3 bg-gradient-to-br from-yellow-50 to-white rounded-xl border border-yellow-100">
                      <h4 className="font-bold text-sm text-[#1B4582] mb-3 flex items-center gap-2">
                        <span className="text-yellow-600">⭐</span>
                        Amenities
                      </h4>
                      <div className="grid grid-cols-3 gap-2">
                        {[
                          "AC",
                          "non-Ac",
                          "Grooming Tools",
                          "Transport",
                          "Outdoor Play",
                        ].map((amenity) => (
                          <FilterToggleButton
                            key={amenity}
                            label={amenity}
                            isActive={selectedFilters.amenities.includes(amenity)}
                            onClick={() => handleAmenityToggle(amenity)}
                            className="text-xs px-2 py-2 hover:scale-105 transition-transform"
                          />
                        ))}
                      </div>
                    </div>
                    {/* Action Buttons (Desktop Dropdown) */}
                    <div className="flex justify-between items-center mt-3 pt-3 border-t-2 border-gray-100 gap-3">
                      <button
                        onClick={clearFilters}
                        className="text-sm text-[#1B4582] hover:text-[#ff4816] font-semibold transition-all hover:scale-105 px-3 py-2 rounded-lg hover:bg-gray-50"
                      >
                        Clear All
                      </button>
                      
                      <button
                      onClick={() => {
                     setFilters(selectedFilters); // Apply the selected filters
                    setIsFilterDropdownOpen(false); // Close dropdown
                      }}
                    className="text-sm bg-gradient-to-r from-[#FF6216] to-[#ff4816] text-white px-6 py-2.5 rounded-xl font-semibold hover:shadow-lg hover:scale-105 transition-all duration-200"
                     >
                    Apply Filters
                   </button>
                    </div>
                  </div>
                )}
              </div>

              {/* Sort Dropdown Button */}
              <div
                className="relative inline-block text-left w-auto"
                ref={sortRef}
              >
                <button
                  type="button"
                  onClick={() => setIsSortDropdownOpen((prev) => !prev)}
                  className={`flex items-center justify-center gap-1 border border-[#FD590133] rounded-full px-2 py-3 text-sm font-medium md:gap-4 md:px-6 md:py-3 md:text-[18px] w-full transition-colors 
                        ${
                          isSortDropdownOpen
                            ? "bg-[#FF6216] text-white border-[#FF6216]"
                            : "bg-white text-[#1B4582] border-[#FD590133] hover:bg-[#FD590120]"
                        }`}
                >
                  <img
                    src="img/arrowImage.png"
                    alt="Sort Arrow"
                    className="w-5 h-5 lg:w-auto lg:h-auto"
                  />
                  <p className="text-base lg:text-[18px]">Sort</p>
                </button>
                {/* Sort Dropdown Menu (Positioned relative to button) */}
                {isSortDropdownOpen && (
                  <div className="origin-top-right absolute right-0 left-auto translate-x-0 mt-3 w-full max-w-xs sm:w-96 rounded-2xl shadow-2xl bg-white ring-1 ring-gray-200 focus:outline-none z-30 animate-[slideDown_0.3s_ease-out] border border-gray-100 max-h-[80vh] overflow-y-auto"
                    onMouseDown={(e) => e.stopPropagation()}
                  >
                    {/* Sort options content */}
                    <div className="p-3">
                      {/* Header */}
                      <div className="mb-3 pb-2 border-b-2 border-gray-100">
                        <h3 className="text-base font-bold text-[#1B4582] flex items-center gap-2">
                          <span className="text-[#FF6216]">⚡</span>
                          Sort Options
                        </h3>
                      </div>

                      <button
                        onClick={() => {
                          setActiveFilter("Price: Low To High");
                          setIsSortDropdownOpen(false);
                        }}
                        className={`w-full text-left px-4 py-3 text-sm flex items-center rounded-xl transition-all mb-2 font-medium ${
                          activeFilter === "Price: Low To High"
                            ? "bg-gradient-to-r from-[#FF6216] to-[#ff4816] text-white shadow-md scale-[1.02]"
                            : "text-[#1B4582] hover:bg-gradient-to-r hover:from-orange-50 hover:to-orange-100 hover:scale-[1.02]"
                        }`}
                      >
                        <span className="mr-3">💸</span>
                        <span className="flex-grow">Price: Low To High</span>
                        {activeFilter === "Price: Low To High" && (
                          <RxCross2 className="ml-2 text-xl" />
                        )}
                      </button>

                      <button
                        onClick={() => {
                          setActiveFilter("Price: High To Low");
                          setIsSortDropdownOpen(false);
                        }}
                        className={`w-full text-left px-4 py-3 text-sm flex items-center rounded-xl transition-all mb-2 font-medium ${
                          activeFilter === "Price: High To Low"
                            ? "bg-gradient-to-r from-[#FF6216] to-[#ff4816] text-white shadow-md scale-[1.02]"
                            : "text-[#1B4582] hover:bg-gradient-to-r hover:from-orange-50 hover:to-orange-100 hover:scale-[1.02]"
                        }`}
                      >
                        <span className="mr-3">💰</span>
                        <span className="flex-grow">Price: High To Low</span>
                        {activeFilter === "Price: High To Low" && (
                          <RxCross2 className="ml-2 text-xl" />
                        )}
                      </button>

                      <button
                        onClick={() => {
                          setActiveFilter("Distance: Nearest First");
                          setIsSortDropdownOpen(false);
                        }}
                        className={`w-full text-left px-4 py-3 text-sm flex items-center rounded-xl transition-all mb-2 font-medium ${
                          activeFilter === "Distance: Nearest First"
                            ? "bg-gradient-to-r from-[#FF6216] to-[#ff4816] text-white shadow-md scale-[1.02]"
                            : "text-[#1B4582] hover:bg-gradient-to-r hover:from-blue-50 hover:to-blue-100 hover:scale-[1.02]"
                        }`}
                      >
                        <span className="mr-3">📍</span>
                        <span className="flex-grow">
                          Distance: Nearest First
                        </span>
                        {activeFilter === "Distance: Nearest First" && (
                          <RxCross2 className="ml-2 text-xl" />
                        )}
                      </button>

                      <button
                        onClick={() => {
                          setActiveFilter("Rating: High To Low");
                          setIsSortDropdownOpen(false);
                        }}
                        className={`w-full text-left px-4 py-3 text-sm flex items-center rounded-xl transition-all font-medium ${
                          activeFilter === "Rating: High To Low"
                            ? "bg-gradient-to-r from-[#FF6216] to-[#ff4816] text-white shadow-md scale-[1.02]"
                            : "text-[#1B4582] hover:bg-gradient-to-r hover:from-yellow-50 hover:to-yellow-100 hover:scale-[1.02]"
                        }`}
                      >
                        <span className="mr-3">⭐</span>
                        <span className="flex-grow">Rating: High To Low</span>
                        {activeFilter === "Rating: High To Low" && (
                          <RxCross2 className="ml-2 text-xl" />
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Desktop Clear Filters (Inline with Filter/Sort) */}
        {/*   {(filters.services.length > 0 ||
              filters.petType.length > 0 ||
              filters.petSize.length > 0 ||
              activeFilter ||
              filters.amenities.length > 0 ||
              filters.availability.length > 0) && (
              <div className="hidden lg:flex items-center gap-2 text-[#1B4582] bg-[#FD590120] border border-[#FD590133] rounded-xl px-4 py-2 w-full sm:w-auto md:mt-0">
                <span className="text-sm">Clear</span>
                <button onClick={clearFiltersAndSort}>
                  <RxCross2 className="text-[#FD5901]" />
                </button>
              </div>
            )}   */}
          </div>
        </div>

        {/* *** 4. MOBILE-ONLY FIXED FILTER AND SORT BAR (Bottom) ****/}
        {!cartOpen && (
        <div className="fixed bottom-0 left-0 right-0 z-20 bg-white shadow-[0_-4px_20px_rgba(0,0,0,0.1)] flex justify-center items-center px-4 py-3 lg:hidden border-t border-gray-200">
          <div className="flex justify-between items-center w-full p-2 rounded-3xl gap-3 md:gap-4">
            {/* Filter and Sort buttons container (Mobile) */}
            <div className=" flex items-center gap-2 w-full justify-between flex-nowrap">
              {/* Filter Button */}
              <div className="relative inline-block text-left w-1/2">
                <button
                  type="button"
                  onClick={toggleFilterDropdown}
                  className={`flex items-center justify-center gap-1 border border-[#FD590133] rounded-full px-2 py-3 text-sm font-medium w-full transition-colors 
                       ${
                         isFilterDropdownOpen
                           ? "bg-[#FF6216] text-white border-[#FF6216]"
                           : "bg-white text-[#1B4582] border-[#FD590133] hover:bg-[#FD590120]"
                       }`}
                >
                  {isFilterDropdownOpen ? (
                    <FaChevronUp className="w-3 h-3" />
                  ) : (
                    <FaChevronDown className="w-3 h-3" />
                  )}
                  <p className="text-base">Filter</p>
                </button>

                {/* --- MOBILE FILTER MODAL START (Bottom Sheet) --- */}
                {isFilterDropdownOpen && (
                  <>
                    <div
                      className="fixed inset-0 bg-black bg-opacity-40 z-[998] lg:hidden"
                      onClick={toggleFilterDropdown} // Tapping the backdrop closes the modal
                    />

                    {/* 2. BOTTOM SHEET CONTAINER (z-[999] ensures it is above the backdrop) */}
                    <div
                      className="fixed bottom-0 left-0 right-0 bg-white z-[999] 
                       h-full max-h-[80vh] rounded-t-2xl shadow-2xl 
                       transform transition-transform duration-300 ease-out 
                       flex flex-col lg:hidden"
                    >
                      <div className="relative flex justify-center items-center px-4 py-4 border-b-2 border-gray-100 sticky top-0 bg-gradient-to-r from-orange-50 via-white to-orange-50 z-10 flex-shrink-0 shadow-sm">
                        {/* Handle bar */}
                        <div className="absolute top-2 left-1/2 -translate-x-1/2 w-12 h-1.5 bg-gray-300 rounded-full"></div>

                        {/* Close button */}
                        <button
                          onClick={toggleFilterDropdown}
                          className="absolute top-[-5rem] left-1/2 -translate-x-1/2 
                               p-1 text-white bg-gradient-to-br from-gray-700 to-gray-800 rounded-full w-16 h-16 
                               flex items-center justify-center shadow-2xl hover:from-gray-800 hover:to-gray-900 transition-all hover:scale-110 z-20"
                        >
                          <RxCross2 className="w-10 h-10 font-bold" />
                        </button>

                        {/* Title */}
                        <h3 className="text-2xl font-bold text-[#1B4582] text-center w-full mt-6 flex items-center justify-center gap-2">
                          <span className="text-[#FF6216]">✦</span>
                          Filter Options
                        </h3>
                      </div>

                      {/* Mobile Modal Content (Scrollable Area) */}
                      <div className="flex-grow overflow-y-auto px-4 pb-20">
                        {/* Price Range Slider */}
                        <div className="mb-3 p-3 bg-gradient-to-br from-orange-50 to-white rounded-2xl border-2 border-orange-100 mt-3">
                          <h4 className="font-bold text-lg text-[#1B4582] mb-3 flex items-center gap-2">
                            <span className="text-2xl">💰</span>
                            Price Range
                          </h4>
                          <div className="flex gap-1 mb-2">
                            <PriceRangeSlider
                              minLimit={MIN_LIMIT}
                              maxLimit={MAX_LIMIT}
                              step={SLIDER_STEP}
                              priceRange={selectedFilters.priceRange}
                              onRangeChange={handlePriceRangeChange}
                            />
                          </div>
                        </div>

                        {/* Pet Type */}
                        <div className="mb-3 p-3 bg-gradient-to-br from-blue-50 to-white rounded-2xl border-2 border-blue-100">
                          <h4 className="font-bold text-lg mb-3 text-[#1B4582] flex items-center gap-2">
                            <span className="text-2xl">🐾</span>
                            Pet Type
                          </h4>
                          <div className="flex gap-3 mb-2">
                            {["Dog", "Cat"].map((type) => (
                              <FilterToggleButton
                                key={type}
                                label={type}
                                isActive={selectedFilters.petType.includes(type)}
                                onClick={() => handlePetTypeToggle(type)}
                                className="text-base px-8 py-4 hover:scale-105 transition-transform"
                              />
                            ))}
                          </div>
                        </div>

                        {/* Pet Size */}
                       {/*  <div className="mb-3 p-3 bg-gradient-to-br from-purple-50 to-white rounded-2xl border-2 border-purple-100">
                          <h4 className="font-bold text-lg mb-3 text-[#1B4582] flex items-center gap-2">
                            <span className="text-2xl">📏</span>
                            Pet Size
                          </h4>
                          <div className="flex gap-3 mb-2 flex-wrap">
                            {["Small", "Medium", "Large", "Giant"].map(
                              (size) => (
                                <FilterToggleButton
                                  key={size}
                                  label={size}
                                  isActive={selectedFilters.petSize.includes(size)}
                                  onClick={() => togglePetSize(size)}
                                  className="text-base px-6 py-3 hover:scale-105 transition-transform"
                                />
                              )
                            )}
                          </div>
                        </div> */}

                        {/* Availability */}
                        <div className="mb-3 p-3 bg-gradient-to-br from-green-50 to-white rounded-2xl border-2 border-green-100">
                          <h4 className="font-bold text-lg mb-3 text-[#1B4582] flex items-center gap-2">
                            <span className="text-2xl">📅</span>
                            Availability
                          </h4>
                          <div className="flex gap-3 text-lg mb-2">
                            {["Today", "Tomorrow"].map((option) => (
                              <FilterToggleButton
                                key={option}
                                label={option}
                                isActive={selectedFilters.availability.includes(option)}
                                onClick={() => handleAvailabilityToggle(option)}
                                className="text-base px-8 py-4 hover:scale-105 transition-transform"
                              />
                            ))}
                          </div>
                        </div>

                        {/* Amenities */}
                        <div className="mb-3 p-3 bg-gradient-to-br from-yellow-50 to-white rounded-2xl border-2 border-yellow-100">
                          <h4 className="font-bold text-lg mb-3 text-[#1B4582] flex items-center gap-2">
                            <span className="text-2xl">⭐</span>
                            Amenities
                          </h4>
                          <div className="grid grid-cols-2 gap-3 text-lg">
                            {[
                              "AC",
                              "non-Ac",
                              "Grooming Tools",
                              "Transport",
                              "Outdoor Play",
                            ].map((amenity) => (
                              <FilterToggleButton
                                key={amenity}
                                label={amenity}
                                isActive={selectedFilters.amenities.includes(amenity)}
                                onClick={() => handleAmenityToggle(amenity)}
                                className="text-sm px-3 py-3 hover:scale-105 transition-transform"
                              />
                            ))}
                          </div>
                        </div>
                      </div>

                      {/* Mobile Fixed Apply Bar (Flex-Shrink-0) */}
                      <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-t from-white via-white to-transparent p-5 border-t-2 border-gray-100 z-[1000] flex-shrink-0 shadow-[0_-4px_20px_rgba(0,0,0,0.1)]">
                        <div className="flex justify-between items-center w-full gap-4">
                          <button
                            onClick={clearFilters}
                            className="text-lg text-[#1B4582] hover:text-[#ff4816] font-bold transition-all px-4 py-3 rounded-xl hover:bg-gray-50 hover:scale-105"
                          >
                            Clear All
                          </button>
                         <button
                             onClick={() => {
                             setFilters(selectedFilters);   // ✅ APPLY
                             setIsFilterDropdownOpen(false); // ✅ CLOSE
                              }}
>
                            Apply Filters
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {/* --- MOBILE FILTER MODAL END --- */}
              </div>

              {/* Sort Dropdown Button (Mobile) */}
              <div
                className="relative inline-block text-left w-1/2"
                ref={sortRef}
              >
                <button
                  type="button"
                  onClick={() => setIsSortDropdownOpen((prev) => !prev)}
                  className={`flex items-center justify-center gap-1 border border-[#FD590133] rounded-full px-2 py-3 text-sm font-medium w-full transition-colors 
                       ${
                         isSortDropdownOpen
                           ? "bg-[#FF6216] text-white border-[#FF6216]"
                           : "bg-white text-[#1B4582] border-[#FD590133] hover:bg-[#FD590120]"
                       }`}
                >
                  {isSortDropdownOpen ? (
                    <FaChevronUp className="w-3 h-3" />
                  ) : (
                    <FaChevronDown className="w-3 h-3" />
                  )}
                  <p className="text-base">Sort</p>
                </button>

                {/* --- MOBILE SORT MODAL START (Bottom Sheet) --- */}
                {isSortDropdownOpen && (
                  <>
                    {/* 1. BACKDROP OVERLAY */}
                    <div
                      className="fixed inset-0 bg-black bg-opacity-40 z-[998] lg:hidden"
                      onClick={() => setIsSortDropdownOpen(false)} // Tapping the backdrop closes the modal
                    />

                    {/* 2. BOTTOM SHEET CONTAINER */}
                    <div
                      className="fixed bottom-0 left-0 right-0 bg-white z-[999] 
                       h-auto max-h-[70vh] rounded-t-2xl shadow-2xl 
                       transform transition-transform duration-300 ease-out 
                       flex flex-col lg:hidden"
                    >
                      <div className="relative flex justify-center items-center px-4 py-4 border-b-2 border-gray-100 sticky top-0 bg-gradient-to-r from-blue-50 via-white to-blue-50 z-10 flex-shrink-0 shadow-sm">
                        {/* Handle bar */}
                        <div className="absolute top-2 left-1/2 -translate-x-1/2 w-12 h-1.5 bg-gray-300 rounded-full"></div>

                        {/* Close button */}
                        <button
                          onClick={() => setIsSortDropdownOpen(false)}
                          className="absolute top-[-5rem] left-1/2 -translate-x-1/2 
                               p-1 text-white bg-gradient-to-br from-gray-700 to-gray-800 rounded-full w-16 h-16 
                               flex items-center justify-center shadow-2xl hover:from-gray-800 hover:to-gray-900 transition-all hover:scale-110 z-20"
                        >
                          <RxCross2 className="w-10 h-10 font-bold" />
                        </button>

                        {/* Title */}
                        <h3 className="text-2xl font-bold text-[#1B4582] text-center w-full mt-6 flex items-center justify-center gap-2">
                          <span className="text-[#FF6216]">⚡</span>
                          Sort Options
                        </h3>
                      </div>

                      {/* Mobile Modal Content (Scrollable Area) */}
                      <div className="flex-grow overflow-y-auto px-4 pb-6 pt-4">
                        <div className="space-y-3">
                          {/* Price: Low To High */}
                          <button
                            onClick={() => {
                              setActiveFilter("Price: Low To High");
                              setIsSortDropdownOpen(false);
                            }}
                            className={`w-full text-left px-4 py-4 text-base flex items-center rounded-2xl transition-all font-medium shadow-sm ${
                              activeFilter === "Price: Low To High"
                                ? "bg-gradient-to-r from-[#FF6216] to-[#ff4816] text-white shadow-lg scale-[1.02]"
                                : "text-[#1B4582] bg-gradient-to-r from-orange-50 to-white border-2 border-orange-100 hover:shadow-md hover:scale-[1.02]"
                            }`}
                          >
                            <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mr-3">
                              <span className="text-2xl">💸</span>
                            </div>
                            <span className="flex-grow">
                              Price: Low To High
                            </span>
                            {activeFilter === "Price: Low To High" && (
                              <RxCross2 className="ml-2 text-2xl" />
                            )}
                          </button>

                          {/* Price: High To Low */}
                          <button
                            onClick={() => {
                              setActiveFilter("Price: High To Low");
                              setIsSortDropdownOpen(false);
                            }}
                            className={`w-full text-left px-4 py-4 text-base flex items-center rounded-2xl transition-all font-medium shadow-sm ${
                              activeFilter === "Price: High To Low"
                                ? "bg-gradient-to-r from-[#FF6216] to-[#ff4816] text-white shadow-lg scale-[1.02]"
                                : "text-[#1B4582] bg-gradient-to-r from-orange-50 to-white border-2 border-orange-100 hover:shadow-md hover:scale-[1.02]"
                            }`}
                          >
                            <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mr-3">
                              <span className="text-2xl">💰</span>
                            </div>
                            <span className="flex-grow">
                              Price: High To Low
                            </span>
                            {activeFilter === "Price: High To Low" && (
                              <RxCross2 className="ml-2 text-2xl" />
                            )}
                          </button>

                          {/* Distance: Nearest First */}
                          <button
                            onClick={() => {
                              setActiveFilter("Distance: Nearest First");
                              setIsSortDropdownOpen(false);
                            }}
                            className={`w-full text-left px-4 py-4 text-base flex items-center rounded-2xl transition-all font-medium shadow-sm ${
                              activeFilter === "Distance: Nearest First"
                                ? "bg-gradient-to-r from-[#FF6216] to-[#ff4816] text-white shadow-lg scale-[1.02]"
                                : "text-[#1B4582] bg-gradient-to-r from-blue-50 to-white border-2 border-blue-100 hover:shadow-md hover:scale-[1.02]"
                            }`}
                          >
                            <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mr-3">
                              <span className="text-2xl">📍</span>
                            </div>
                            <span className="flex-grow">
                              Distance: Nearest First
                            </span>
                            {activeFilter === "Distance: Nearest First" && (
                              <RxCross2 className="ml-2 text-2xl" />
                            )}
                          </button>

                          {/* Rating: High To Low */}
                          <button
                            onClick={() => {
                              setActiveFilter("Rating: High To Low");
                              setIsSortDropdownOpen(false);
                            }}
                            className={`w-full text-left px-4 py-4 text-base flex items-center rounded-2xl transition-all font-medium shadow-sm ${
                              activeFilter === "Rating: High To Low"
                                ? "bg-gradient-to-r from-[#FF6216] to-[#ff4816] text-white shadow-lg scale-[1.02]"
                                : "text-[#1B4582] bg-gradient-to-r from-yellow-50 to-white border-2 border-yellow-100 hover:shadow-md hover:scale-[1.02]"
                            }`}
                          >
                            <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mr-3">
                              <span className="text-2xl">⭐</span>
                            </div>
                            <span className="flex-grow">
                              Rating: High To Low
                            </span>
                            {activeFilter === "Rating: High To Low" && (
                              <RxCross2 className="ml-2 text-2xl" />
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {/* --- MOBILE SORT MODAL END --- */}
              </div>

              {/* Clear Filters on Mobile (Inline with Filter/Sort) */}
            {/*  {(filters.services.length > 0 ||
                filters.petType.length > 0 ||
                filters.petSize.length > 0 ||
                activeFilter ||
                filters.amenities.length > 0 ||
                filters.availability.length > 0) && (
                <div className="flex lg:hidden items-center gap-2 text-[#1B4582] bg-[#FD590120] border border-[#FD590133] rounded-xl px-1 py-1 w-1/2 sm:w-auto justify-center mt-3">
                  <span className="text-xs">Clear</span>
                  <button onClick={clearFiltersAndSort}>
                    <RxCross2 className="text-[#FD5901]" />
                  </button>
                </div>
              )} */}
            </div>
          </div>
        </div>
        )}

        {/* --- ACTIVE FILTERS DISPLAY (Pills) --- */}       
        {/* --- ACTIVE FILTERS & RESULTS COUNT (Modern Chips Style) --- */}
        <div className="px-10 pt-3 pb-4 flex flex-col gap-3 bg-white lg:bg-transparent xl:px-12 lg:pt-0 lg:pb-2 sticky top-[env(safe-area-inset-top)]  lg:static lg:z-auto">
          {/* Horizontal scrollable chips row */}
          <div className="flex items-center gap-2.5 overflow-x-auto pb-1 scrollbar-hide whitespace-nowrap">
            {/* Search chip */}
            {searchQuery && (
              <div className="flex items-center gap-1.5 px-3.5 py-1.5 bg-[#FD590120] border border-[#FD590133] rounded-full text-sm text-[#1B4582] flex-shrink-0">
                <span className="font-medium">{searchQuery}</span>
                <button
                  onClick={() => setSearchQuery("")}
                  className="text-[#FD5901] hover:text-[#FF6216] focus:outline-none"
                  aria-label="Clear search"
                >
                  <RxCross2 size={16} />
                </button>
              </div>
            )}

            {/* Sort chip */}
            {activeFilter && (
              <div className="flex items-center gap-1.5 px-3.5 py-1.5 bg-[#FD590120] border border-[#FD590133] rounded-full text-sm text-[#1B4582] flex-shrink-0">
                <span className="font-medium">{activeFilter}</span>
                <button
                  onClick={() => setActiveFilter(null)}
                  className="text-[#FD5901] hover:text-[#FF6216] focus:outline-none"
                  aria-label="Clear sort"
                >
                  <RxCross2 size={16} />
                </button>
              </div>
            )}

            {/* Boarding services */}
            {selectedBoardingServices.map((service) => (
              <div
                key={service}
                className="flex items-center gap-1.5 px-3.5 py-1.5 bg-[#FD590120] border border-[#FD590133] rounded-full text-sm text-[#1B4582] flex-shrink-0"
              >
                <span className="font-medium">{service}</span>
                <button
                  onClick={() => toggleSubService(service)}
                  className="text-[#FD5901] hover:text-[#FF6216] focus:outline-none"
                  aria-label={`Remove ${service}`}
                >
                  <RxCross2 size={16} />
                </button>
              </div>
            ))}

            {/* Grooming services */}
            {selectedGroomingServices.map((service) => (
              <div
                key={service}
                className="flex items-center gap-1.5 px-3.5 py-1.5 bg-[#FD590120] border border-[#FD590133] rounded-full text-sm text-[#1B4582] flex-shrink-0"
              >
                <span className="font-medium">{service}</span>
                <button
                  onClick={() => toggleSubService(service)}
                  className="text-[#FD5901] hover:text-[#FF6216] focus:outline-none"
                  aria-label={`Remove ${service}`}
                >
                  <RxCross2 size={16} />
                </button>
              </div>
            ))}

            {/* Veterinary */}
            {isVeterinarySelected && (
              <div className="flex items-center gap-1.5 px-3.5 py-1.5 bg-[#FD590120] border border-[#FD590133] rounded-full text-sm text-[#1B4582] flex-shrink-0">
                <span className="font-medium">Veterinary</span>
                <button
                  onClick={() => toggleSimpleService("Veterinary")}
                  className="text-[#FD5901] hover:text-[#FF6216] focus:outline-none"
                  aria-label="Remove Veterinary"
                >
                  <RxCross2 size={16} />
                </button>
              </div>
            )}

            {/* Pet Type */}
            {filters.petType.map((type) => (
              <div
                key={type}
                className="flex items-center gap-1.5 px-3.5 py-1.5 bg-[#FD590120] border border-[#FD590133] rounded-full text-sm text-[#1B4582] flex-shrink-0"
              >
                <span className="font-medium">{type}</span>
                <button
                  onClick={() => removeFilterPill("petType", type)}
                  className="text-[#FD5901] hover:text-[#FF6216] focus:outline-none"
                  aria-label={`Remove ${type}`}
                >
                  <RxCross2 size={16} />
                </button>
              </div>
            ))}

            {/* Pet Size */}
           {/* {filters.petSize.map((size) => (
              <div
                key={size}
                className="flex items-center gap-1.5 px-3.5 py-1.5 bg-[#FD590120] border border-[#FD590133] rounded-full text-sm text-[#1B4582] flex-shrink-0"
              >
                <span className="font-medium">{size}</span>
                <button
                  onClick={() => removeFilterPill("petSize", size)}
                  className="text-[#FD5901] hover:text-[#FF6216] focus:outline-none"
                  aria-label={`Remove ${size}`}
                >
                  <RxCross2 size={16} />
                </button>
              </div>
            ))} */}

            {/* Price Range */}
            {filters.priceRange[1] !== MAX_LIMIT && (
              <div className="flex items-center gap-1.5 px-3.5 py-1.5 bg-[#FD590120] border border-[#FD590133] rounded-full text-sm text-[#1B4582] flex-shrink-0">
                <span className="font-medium">Up to ₹{filters.priceRange[1]}</span>
                <button
                  onClick={() => setFilters((prev) => ({ ...prev, priceRange: [MIN_LIMIT, MAX_LIMIT] }))}
                  className="text-[#FD5901] hover:text-[#FF6216] focus:outline-none"
                  aria-label="Clear price range"
                >
                  <RxCross2 size={16} />
                </button>
              </div>
            )}

            {/* Availability */}
            {filters.availability.map((option) => (
              <div
                key={option}
                className="flex items-center gap-1.5 px-3.5 py-1.5 bg-[#FD590120] border border-[#FD590133] rounded-full text-sm text-[#1B4582] flex-shrink-0"
              >
                <span className="font-medium">{option}</span>
                <button
                  onClick={() => removeFilterPill("availability", option)}
                  className="text-[#FD5901] hover:text-[#FF6216] focus:outline-none"
                  aria-label={`Remove ${option}`}
                >
                  <RxCross2 size={16} />
                </button>
              </div>
            ))}

            {/* Amenities */}
            {filters.amenities.map((amenity) => (
              <div
                key={amenity}
                className="flex items-center gap-1.5 px-3.5 py-1.5 bg-[#FD590120] border border-[#FD590133] rounded-full text-sm text-[#1B4582] flex-shrink-0"
              >
                <span className="font-medium">{amenity}</span>
                <button
                  onClick={() => removeFilterPill("amenities", amenity)}
                  className="text-[#FD5901] hover:text-[#FF6216] focus:outline-none"
                  aria-label={`Remove ${amenity}`}
                >
                  <RxCross2 size={16} />
                </button>
              </div>
            ))}

            {/* Clear All – shown only when there are active filters */}
            {(searchQuery ||
              activeFilter ||
              filters.services.length > 0 ||
              filters.petType.length > 0 ||
              filters.petSize.length > 0 ||
              filters.priceRange[1] !== MAX_LIMIT ||
              filters.availability.length > 0 ||
              filters.amenities.length > 0) && (
              <button
                onClick={() => {
                    clearFiltersAndSort();     // clears filters + sort
                    setSearchQuery("");        // ← FIXED: now clears search too
                  }}
                className="text-base text-[#FF6216] font-bold px-2 py-1 hover:underline flex-shrink-0"
                aria-label="Clear all filters and sort"
              >
                Clear all
              </button>
            )}
          </div>
        </div>

        {/* --- Vendor List and Map (Rest of the content) --- */}

        {/* Loading State */}
        {loading && (
          <div className="mt-8 text-center">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[#FF6216]"></div>
            <p className="mt-2 text-gray-600">Loading vendors...</p>
          </div>
        )}

        
        {/* Vendor List + Map */}
        <div className="mt-6">
          <div className="flex flex-col lg:flex-row px-4 lg:px-4 gap-8">
            <div className="w-full lg:w-[65%]">
              {!loading && !error && (
                <p className="px-8 text-md font-medium text-[#000048] xl:px-10 lg:px-8">
                 Showing {sortedVendors.length} Vendor
                  {sortedVendors.length !== 1 ? "s" : ""} near your location
                </p>
              )}
              {sortedVendors.map((v, index) => {
                let distanceInKm = null;

                if (userLocation) {
                  const vendorLat =
                    v?.address?.officeAddress?.latitude ?? v?.lat ?? null;
                  const vendorLon =
                    v?.address?.officeAddress?.longitude ?? v?.long ?? null;

                  if (vendorLat !== null && vendorLon !== null) {
                    distanceInKm = getDistanceFromLatLonInKm(
                      userLocation.lat,
                      userLocation.lon,
                      vendorLat,
                      vendorLon
                    ).toFixed(2);
                  }
                }

                const mondayHours = v.businessHours?.find(
                  (day) => day.day === "Monday"
                );

                const mondayTiming = mondayHours
                  ? mondayHours.closed
                    ? "Closed"
                    : mondayHours.slots?.length
                    ? `${mondayHours.slots[0].start} - ${mondayHours.slots[0].end}`
                    : "Open All Day"
                  : "";

                const calculatedPrice = calculateLowestPrice(v);
                const flatVendor = {
                  _id: v.vendor_id || v._id,
                  id: v._id,
                  name: v.name || v.profile?.name,
                  companyName: v.companyName || v.profile?.companyName,
                  about: v.about || v.profile?.about,
                  brand: v.brand || v.profile?.brand,
                  distance: distanceInKm ? `${distanceInKm} km` : "",
                  area:
                    v.area || v.address?.officeAddress?.full_address ||v.address?.homeAddress?.full_address || null,
                  state: v.address?.officeAddress?.state || v.address?.homeAddress?.state || "",
                  pincode: v.address?.officeAddress?.pincode || v.address?.homeAddress?.pincode || "null",

                  locality:
                      v.address?.officeAddress?.locality || v.address?.homeAddress?.locality || null,
                 // photo: v.photo || "",
                 photo: v.photo?.profilePhoto || "",
                 logo: v.logo || "",
                  status: v.status || "Open",
                  //subscription_type: v.subscription_type || "",
                  time: mondayTiming || "09:30 AM - 08:30 PM",
                  price: calculatedPrice > 0 ? `₹${calculatedPrice}` : "",
                  available: v.available || "Available now",
                  features: v.features || v.ameneties || [],
                  description:
                    v.about || v.profile?.about || "No description available",
                  services: filterVisibleVendorServices(v.services),

                  start_rating: v.reviews?.rating || v.start_rating || "No Rating",

                  // 3. Fetch the total count of reviews from the correct DB path
                 total_review: v.reviews?.totalRatings || v.total_review || 0,

                  rating: calculateBestRating(v) || 0,
                  businessHours: v.businessHours,
                  location: v.location || "",
                  petType: v.petTyps || [],
                  petSize: v.petSizes || [],

                  priceSettings: v.priceSettings || null, 
                  amenities:v.amenities||"",
  
                   subscription_type: v.subscription_type || "",
                };

                return (
                  <div 
                      key={flatVendor._id}
                      onMouseEnter={() => {
                    // Log this to your console to see what is being sent
                      setHoveredVendorId(flatVendor._id);
                    }}
                    onMouseLeave={() => setHoveredVendorId(null)}
                  >
                  <FilterCard  vendor={flatVendor} className="" />
                  </div>
                );
              })}
            </div>
            <div className="w-full lg:w-[35%]">
              <div className="lg:sticky lg:top-24">
                <p className="text-sm text-[#000048] mb-5">Enlarge Map</p>
                <div className="w-full mb-4 rounded-lg">
                  <div className="w-full mb-24 sm:mb-28 lg:mb-9 rounded-lg">
                    {sortedVendors.length > 0 ? (
                      <VendorMap vendors={sortedVendors} 
                                  hoveredVendorId={hoveredVendorId}
                                  setHoveredVendorId={setHoveredVendorId} 
                      />
                    ) : (
                      <div className="flex items-center justify-center h-full text-gray-500">
                        No vendors to show on map.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>
      )}
    </div>
  );
};

export default ShopDetail;
